import { useState } from 'react';

import { request } from '../sync/api.js';

/**
 * Привязка Telegram.
 *
 * Приложение просит у сервера одноразовый код и открывает бота по ссылке.
 * Ни пароль, ни токен сессии в переписку не попадают — код живёт 15 минут
 * и годится только для того, чтобы связать чат с учётной записью.
 */
interface LinkResponse {
  url: string | null;
  expiresAt: string;
}

export function TelegramLink(): JSX.Element {
  const [state, setState] = useState<
    { kind: 'idle' } | { kind: 'busy' } | { kind: 'ready'; url: string } | { kind: 'error'; message: string }
  >({ kind: 'idle' });

  const create = async (): Promise<void> => {
    setState({ kind: 'busy' });
    try {
      const response = await request<LinkResponse>(
        '/api/notifications/telegram-link',
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' },
        20_000,
      );
      if (!response.url) {
        setState({
          kind: 'error',
          message: 'На сервере не указано имя бота — обратитесь к администратору',
        });
        return;
      }
      setState({ kind: 'ready', url: response.url });
      window.open(response.url, '_blank', 'noopener');
    } catch (error) {
      setState({
        kind: 'error',
        message: error instanceof Error ? error.message : 'Не удалось получить ссылку',
      });
    }
  };

  return (
    <div>
      <button
        type="button"
        disabled={state.kind === 'busy'}
        onClick={() => void create()}
        className="w-full rounded-xl bg-muted px-5 py-4 text-lg font-semibold active:bg-line disabled:opacity-50"
      >
        {state.kind === 'busy' ? 'Готовлю ссылку…' : 'Привязать Telegram'}
      </button>

      {state.kind === 'ready' && (
        <p className="mt-3 text-base text-body">
          Откройте бота и нажмите «Начать». Если окно не открылось —{' '}
          <a href={state.url} target="_blank" rel="noopener" className="text-sky-400 underline">
            перейдите по ссылке
          </a>
          . Она действует 15 минут.
        </p>
      )}
      {state.kind === 'error' && <p className="mt-3 text-base text-red-300">{state.message}</p>}

      <p className="mt-2 text-base text-dim">
        Уведомления придут в Telegram. В приложении они видны в любом случае, в том числе без сети.
      </p>
    </div>
  );
}
